module.exports = __webpack_public_path__ + "media/my_images/logo-4de6db1c1079f203dd8746573f38f08b.svg";